module.exports = __webpack_public_path__ + "static/media/meetings.dc0f0581.jpg";